import { useEffect, useRef, useState } from "react";

const useModalTimer = (isOpen, onClose, duration = 60000) => {
  const timerRef = useRef(null);
  const intervalRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(Math.floor(duration / 1000));

  useEffect(() => {
    if (isOpen) {
      // ریست کردن زمان
      setTimeLeft(Math.floor(duration / 1000));

      // پاک کردن تایمرهای قبلی
      if (timerRef.current) clearTimeout(timerRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);

      // تایمر اصلی برای بستن
      timerRef.current = setTimeout(() => {
        onClose();
      }, duration);

      // اینتروال برای شمارش معکوس
      intervalRef.current = setInterval(() => {
        setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isOpen, onClose, duration]);

  return { timeLeft };
};

export default useModalTimer;